import * as React from 'react';
import { AppState } from '@app/store';
import { connect } from 'react-redux';
import './style.scss';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import plural from 'plural-ru';
import { SearchServiceSuggestionProps } from './SearchServiceSuggestionProps';

const mapStateToProps = (state: AppState) => ({
  moreCount: state.search.moreCount,
});

const SearchServiceSuggestion: React.FC<SearchServiceSuggestionProps> = ({
  moreCount,
  suggestion,
  query,
  theme,
}) => {
  if (suggestion.isCount) {
    const result = plural(moreCount, 'результат', 'результата', 'результатов');
    return (
      <a
        href={`https://www.mos.ru/search?category=services&page=1&q=${query}`}
        target="_blank"
        rel="noopener noreferrer"
        className="mos-catalog-search-suggestion__more-link"
        onClick={(e) => {
          e.preventDefault();
        }}
      >
        Ещё {moreCount} {result}
      </a>
    );
  }

  const matches = match(suggestion.title, query);
  const parts = parse(suggestion.title, matches);

  return (
    <div>
      {parts.map((part, index) => {
        const className = part.highlight ? theme.suggestionHighlight : null;
        const key = `${part.text}=${index}`;
        return (
          <span className={className} key={key}>
            {part.text}
          </span>
        );
      })}
    </div>
  );
};

const SearchServiceSuggestionConnected = connect(mapStateToProps)(
  SearchServiceSuggestion
);

export default SearchServiceSuggestionConnected;
